import t from './story06.translations'

export default {
  title: t.title,
  excerpt: t.excerpt,

  prose: [
    // Run 1 — the open: why South America, and who Dorador is.
    [
      { text: t.s1P1 },
      { text: t.s1P2 },
      { text: t.s1P3 },
      { text: t.s1P4 },
      { text: t.s1P5 },
    ],
    // Run 2 — the interview proper begins: the framing line, then Q1 and Q2.
    [
      { text: t.s2P1 },
      { text: t.s2P2 },
      { text: t.s2P3 },
      { text: t.s2P4 },
      { text: t.s2P5 },
      { text: t.s2P6 },
    ],
    // Run 3 — resumes Dorador's answer after the pull quote, then Q3.
    [
      { text: t.s3P1 },
      { text: t.s3P2 },
      { text: t.s3P3 },
      { text: t.s3P4 },
      { text: t.s3P5 },
    ],
    // Run 4 — the close: Q4, Q5 and Q6 with their answers.
    [
      { text: t.s4P1 },
      { text: t.s4P2 },
      { text: t.s4P3 },
      { text: t.s4P4 },
      { text: t.s4P5 },
      { text: t.s4P6 },
    ],
  ],

  captions: [
    // 01 — hero, the Atacama Desert.
    [t.f1P1],
    // 02 — Cristina Dorador.
    [t.f2P1],
    // 03 — Dorador at work.
    [t.f3P1],
  ],

  quotes: [
    {
      text: t.q1,
      attribution: t.q1Attr,
    },
  ],
} as const
